import { createStyles, Title, Text, Button, Container, Group, rem } from '@mantine/core';
import { IconHome, IconKey } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: rem(80),
    paddingBottom: rem(80),
  },

  label: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: rem(220),
    lineHeight: 1,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
    color: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],

    [theme.fn.smallerThan('sm')]: {
      fontSize: rem(120),
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    textAlign: 'center',
    fontWeight: 900,
    fontSize: rem(24),

    [theme.fn.smallerThan('sm')]: {
      fontSize: rem(32),
    },
  },

  description: {
    maxWidth: rem(500),
    margin: 'auto',
    marginTop: theme.spacing.xl,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
  },
}));

const GeneralErrorScreen = ({ message }) => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Container className={classes.root}>
      <div className={classes.label}>Error</div>
      <Title className={classes.title}>{message || 'Whoops.. Looks like we hit a snag.. Please try your request again. If the problem persists, please report the problem to the IT team.'}</Title>
      <Group position="center" mt={25}>
        <Button
          href="#"
          size="xl"
          variant="default"
          leftIcon={<IconHome />}
          onClick={() => navigate('/')}
        >
          Return Home
        </Button>
      </Group>
    </Container>
  );
}

export default GeneralErrorScreen;